const initState = {
    fetching: false,
    fetched: false,
    message: null,
    data: null,
    error: null,
    success: null,
    type: null,
    role: null,
}

const roleReducer = (state = initState, action) => {
    switch (action.type) {
        case 'FETCH_ROLE_PENDING':
            return {
                ...state,
                fetching: true,
                error: null
            }
        case 'FETCH_ROLE_SUCCESS':

            return {
                ...state,
                fetching: false,
                fetched: true,
                data: action.data,
                success: true,
                type: 'fetch'
            }

        case 'FETCH_ROLE_FAILED':
            return {
                ...state,
                fetching: false,
                fetched: true,
                error: action.error,
                message: action.error.data.message,
                success: false,
                type: 'fetch'
            }
        case 'SAVE_ROLE_PENDING':
            return {
                ...state,
                fetching: true,
            }
        case 'SAVE_ROLE_SUCCESS':

            return {
                ...state,
                fetching: false,
                fetched: true,
                message: action.message,
                type: 'save',
                success: true
            }

        case 'SAVE_ROLE_FAILED':
            return {
                ...state,
                fetching: false,
                fetched: true,
                error: action.error,
                message: action.message,
                type: 'save',
                success: false
            }
        case 'GET_ROLE_PENDING':
            return {
                ...state,
                fetching: true,
            }
        case 'GET_ROLE_SUCCESS':

            return {
                ...state,
                fetching: false,
                fetched: true,
                type: 'get',
                role: action.data,
                success: true
            }

        case 'GET_ROLE_FAILED':
            return {
                ...state,
                fetching: false,
                fetched: true,
                error: action.error,
                message: action.message,
                type: 'get',
                success: false
            }
        case 'UPDATE_ROLE_PENDING':
            return {
                ...state,
                fetching: true,
            }
        case 'UPDATE_ROLE_SUCCESS':

            return {
                ...state,
                fetching: false,
                fetched: true,
                message: action.message,
                type: 'update',
                success: true
            }

        case 'UPDATE_ROLE_FAILED':
            return {
                ...state,
                fetching: false,
                fetched: true,
                error: action.error,
                message: action.message,
                type: 'update',
                success: false
            }
        case 'TOGGLE_ROLE_PENDING':
            return {
                ...state,
                // fetching: true,
            }
        case 'TOGGLE_ROLE_SUCCESS':

            return {
                ...state,
                // fetching: false,
                // fetched: true,
                // message: action.message,
                // type: 'toggle',
                // success: true
            }

        case 'TOGGLE_ROLE_FAILED':
            return {
                ...state,
                // fetching: false,
                // fetched: true,
                error: action.error,
                // message: action.message,
                type: 'toggle',
                // success: false
            }
        case 'DELETE_ROLE_PENDING':
            return {
                ...state,
                fetching: true,
            }
        case 'DELETE_ROLE_SUCCESS':

            return {
                ...state,
                fetching: false,
                fetched: true,
                type: 'delete',
                message: action.message,
                success: true
            }

        case 'DELETE_ROLE_FAILED':
            return {
                ...state,
                fetching: false,
                fetched: true,
                error: action.error,
                message: action.message,
                type: 'delete',
                success: false
            }
        default:
            return state
    }
}

export default roleReducer